import styledConsts from 'app/styles/styledConsts';
import styledFuncs from 'app/styles/styledFuncs';
import styledMixins from 'app/styles/styledMixins';
import { plainStyle } from 'app/styles/theme';
import { css } from 'styled-components/macro';

export type SharedInputProps = {
  $greyPlaceholder?: boolean;
  $noHelperText?: boolean;
  $minHeight?: number;
  multiline?: boolean;
  FormHelperTextProps?: { component?: 'div' };
};

export const sharedInputStyle = css<SharedInputProps>`
  min-height: ${p => p.$minHeight || styledConsts.formItemHeight}px;

  .MuiOutlinedInput-root {
    ${styledMixins.roundCorners}
    ${styledMixins.bodyFontLarger}
    
    &${plainStyle} .MuiOutlinedInput-notchedOutline {
      border-color: #c7c4c4;
    }

    ${p =>
      p.multiline &&
      css`
        padding: 14px;
        // NOTE: if $minHeight = 0 then it doesn't matter px or em
        min-height: ${p.$minHeight ?? 1.4 * 7}${p.$minHeight ? 'px' : 'em'};
        align-items: flex-start;
      `}

    .MuiOutlinedInput-input {
      padding-top: 0;
      padding-bottom: 0;
      position: relative;
      ${p =>
        !p.multiline && styledMixins.formItemHeight(p.$minHeight)}
      text-overflow: ellipsis;

      &::placeholder {
        color: ${p => p.theme.palette.primary.main};
        opacity: 1;
        text-overflow: ellipsis;

        ${p =>
          p.$greyPlaceholder &&
          css`
            font-style: italic;
            color: #999;
            font-size: ${styledFuncs.pxToRem(15)};
          `};
      }
    }
  }

  .MuiFormHelperText-root {
    margin-bottom: ${p =>
      p.$noHelperText ? '0px' : styledFuncs.pad(-1)};
    transition: ${styledFuncs.createTransition(['margin-bottom'])};
  }
`;
